/**
 * Finds the closest parent element that is included in the provided collection of elements
 * @param element - DOM element for which we're searching the parent
 * @param possibleParents - HTMLCollection or array of DOM elements among which we're searching for a parent
 * @returns the closest parent element or null if none is found
 */
export default function findNearestParent(element: HTMLElement, possibleParents: HTMLElement[] | HTMLCollection | NodeListOf<Element>): HTMLElement | null {
  // If the passed element is null or undefined, return null
  if (!element) {
    return null;
  }

  let currentElement: HTMLElement | null = element.parentElement;

  // Traverse up the DOM tree
  while (currentElement) {
    // Check if the current element is in the list of possible parents
    // Convert HTMLCollection or NodeList to Array if needed
    const parentsArray = Array.from(possibleParents);
    if (parentsArray.includes(currentElement)) {
      return currentElement;
    }
    // If not, move to its parent
    currentElement = currentElement.parentElement;
  }

  // If no parent element was found
  return null;
}
